import { TlfContextProps } from "./interface";
import { tlfInitialState } from "./tlfContextInitialState";

/**
 * Clears the active TLF state back to its initial values.
 *
 * @returns Reset TLF context state.
 */
export const tlf_clearTlf = (): TlfContextProps => ({ ...tlfInitialState });
